/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetPipeSeriesStatus200, GetPipeSeriesStatus401 } from '../types/GetPipeSeries'
import type { QueryKey, QueryClient, UseSuspenseQueryOptions, UseSuspenseQueryResult } from '@tanstack/react-query'
import { getPipeSeries } from '../clients/getPipeSeries'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

export const getPipeSeriesSuspenseQueryKey = () => [{ url: '/pipe-series/' }] as const

type GetPipeSeriesSuspenseQueryKey = ReturnType<typeof getPipeSeriesSuspenseQueryKey>

export function getPipeSeriesSuspenseQueryOptions(config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getPipeSeriesSuspenseQueryKey()
  return queryOptions<GetPipeSeriesStatus200, ResponseErrorConfig<GetPipeSeriesStatus401>, GetPipeSeriesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return getPipeSeries({ ...config, signal: config.signal ?? signal, throwOnError: true }).unwrap()
   },
  })
}

/**
 * {@link /pipe-series/}
 */
export function useGetPipeSeriesSuspense<TData = GetPipeSeriesStatus200, TQueryKey extends QueryKey = GetPipeSeriesSuspenseQueryKey>(options: {
  query?: Partial<UseSuspenseQueryOptions<GetPipeSeriesStatus200, ResponseErrorConfig<GetPipeSeriesStatus401>, TData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getPipeSeriesSuspenseQueryKey()

  const queryResult = useSuspenseQuery({
   ...getPipeSeriesSuspenseQueryOptions(config),
   ...resolvedOptions,
   queryKey,
  } as unknown as UseSuspenseQueryOptions, queryClient) as UseSuspenseQueryResult<TData, ResponseErrorConfig<GetPipeSeriesStatus401>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
